import { Component } from '@angular/core';

@Component({
  selector: 'app-filters-container',
  template: `
    <div class="filters-container">
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./filters-container.component.scss'],
  standalone: false,
})
export class FiltersContainerComponent {}
